import { notification } from "antd";
import React from "react";

let toasterInstance;

const Toaster = () => {
  const [api, contextHolder] = notification.useNotification();
  toasterInstance = api;

  return <>{contextHolder}</>;
};

export const showNotification = (...args) => {
  let type, message, description, duration;

  // If the first argument is an object, destructure it.
  if (typeof args[0] === "object" && args[0] !== null) {
    ({ type, message, description = "", duration = 3 } = args[0]);
  } else {
    // Otherwise, assume the parameters are passed individually.
    [type, message, description = "", duration = 3] = args;
  }

  if (toasterInstance && typeof toasterInstance[type] === "function") {
    toasterInstance[type]({
      message,
      description,
      duration,
    });
  }
};

export default Toaster;
